import {Box, Button, Checkbox, Typography} from '@viptech/react-components'
import {useSnackbar} from 'notistack'
import {useEffect, useState} from 'react'
import {MultiSelect, MultiSelectContent, MultiSelectItem, MultiSelectScrollView, MultiSelectValue, SelectValue} from 'src/components/multi-select/MultiSelect'
import {objectTypeList} from 'src/pages/alarms/AlarmsFunctions'
import ConfidenceSliderComponent from 'src/pages/camera-config/components/object-detection/components/stepperModal/components/config-step/ConfidenceSliderComponent'
import PermanenceThreshold from 'src/pages/camera-config/components/object-detection/components/stepperModal/components/config-step/PermanenceThreshold'
import ThresholdComponent from 'src/pages/camera-config/components/object-detection/components/stepperModal/components/config-step/ThresholdComponent'
import ToleranceThreshold from 'src/pages/camera-config/components/object-detection/components/stepperModal/components/config-step/ToleranceThreshold'
import {useCameraConfigContext} from 'src/pages/camera-config/context/CameraConfigContext'
import {useWindowSize} from 'usehooks-ts'
import Dropdown from '../../../../../../../../components/dropdown/Dropdown'
import api, {CameraHasObjects, ObjectType} from '../../../../../../../../services/api'
import {StepperModalActionsButtonContainer} from '../../../styles'
import {ChosenObject} from '../../StepperModal'
import {
  animalsOptions,
  countingObjectsOptions,
  detectionsWithSimpleChoicesToRecognition,
  dontShowDropdownSelectForDetections,
  epiOptions,
  objectsOptions,
  skipFourthStep,
  vehicleOptions,
} from '../Constants'
import {MultipleActionsType} from '../create-multiple-actions/types/CreateMultipleActionsTypes'
import {ConfigContainer, Grid} from './ConfigStepBase'

type ConfigStepProps = {
  nextFunction: (index: number, resume: string) => void
  returnFunction: (index: number) => void
  setChosen: (choices: Partial<ChosenObject>) => void
  chosen: ChosenObject | null
  finishFunction: () => void
  registeredObjects: CameraHasObjects[] | undefined
  isEdit: boolean
  actions: MultipleActionsType[]
}

const ConfigStep = (props: ConfigStepProps) => {
  const {nextFunction, returnFunction, chosen, setChosen, finishFunction, registeredObjects, isEdit, actions} = props
  const {camera} = useCameraConfigContext()
  const {enqueueSnackbar} = useSnackbar()
  const windowSize = useWindowSize()
  const allObjects: ObjectType[] = objectTypeList

  const validateConfiance = chosen?.confidence ?? 0.4
  const [valueSlider, setValueSlider] = useState<number | null>(validateConfiance * 100)
  const [detectionTypeOnDropdownSelected, setDetectionTypeOnDropdownSelected] = useState({id: '', label: ''})

  const [amountOfDetectionSelected, setAmountOfDetectionSelected] = useState(chosen?.threshold?.toString() ?? '')
  const [checkboxState, setCheckboxState] = useState(true)
  const [toleranceThresholdValue, setToleranceThresholdValue] = useState(camera?.configuration.thresholdToDispatchDetection ?? 10)

  const [selectedMultipleItensToCheck, setSelectedMultipleItensToCheck] = useState<SelectValue[]>([])
  const [multipleOptionsOnMultiSelect, setMultipleOptionsOnMultiSelect] = useState<SelectValue[]>([])

  const allowGoNextFunction = () => {
    if (skipFourthStep.includes(chosen?.detectionTypeChosen ?? '')) return false
    else if (!checkboxState) return false
    return true
  }

  const labelNextButton = () => {
    return allowGoNextFunction() ? 'Próximo' : 'Finalizar'
  }

  const functionNextButton = async () => {
    try {
      if (camera && camera?.configuration.thresholdToDispatchDetection !== toleranceThresholdValue) {
        await api.camera.updateCamera(camera.id, {configuration: {thresholdToDispatchDetection: toleranceThresholdValue}})
      }
      if (allowGoNextFunction()) {
        nextFunction(3, 'Concluído')
        return
      }
      finishFunction()
    } catch (err) {
      enqueueSnackbar('Não foi possível salvar sua configuração de tempo de permanência')
    }
  }

  const functionToDisabledButton = () => {
    if (dontShowDropdownSelectForDetections.includes(chosen?.detectionTypeChosen?.toLowerCase() ?? '')) return false
    if (detectionsWithSimpleChoicesToRecognition.includes(chosen?.detectionTypeChosen?.toLowerCase() ?? '') && detectionTypeOnDropdownSelected.id !== '')
      return false
    if (!detectionsWithSimpleChoicesToRecognition.includes(chosen?.detectionTypeChosen?.toLowerCase() ?? '') && selectedMultipleItensToCheck.length)
      return false
    return true
  }

  const handleTitlesAndSubtitlesForDetections = () => {
    if (chosen === null || chosen.detectionTypeChosen === '') return {title: '', subtitle: ''}
    if (chosen.detectionTypeChosen === 'Relatório de Contagem') return {title: 'Tipo do Objeto', subtitle: 'Escolha abaixo o objeto que deseja contar'}
    if (chosen.detectionTypeChosen?.toLowerCase().includes('epi'))
      return {title: 'Monte seu equipamento de segurança', subtitle: 'Escolha abaixo os itens que você deseja detectar a ausência '}
    if (chosen.detectionTypeChosen?.toLowerCase().includes('veículos'))
      return {title: 'Tipos de Veículos', subtitle: 'Escolha abaixo um ou mais veículos que você deseja detectar'}
    if (chosen.detectionTypeChosen?.toLowerCase().includes('objetos'))
      return {title: 'Tipos de Objetos', subtitle: 'Escolha abaixo um ou mais objetos que você deseja detectar'}
    return {
      title: `Escolha o tipo de ${chosen.detectionTypeChosen?.toLowerCase()}`,
      subtitle: `Escolha abaixo o tipo de ${chosen.detectionTypeChosen?.toLowerCase()} que deseja detectar`,
    }
  }

  const handleMultipleSelectionsFunction = (selections: SelectValue[]) => {
    setSelectedMultipleItensToCheck(selections)
    setChosen({detectionsOptionsSelected: selections.map((it) => it.value)})
  }

  const DropdownToChooseTypeOfObjects = () => {
    if (!chosen || dontShowDropdownSelectForDetections.includes(chosen.detectionTypeChosen?.toLowerCase() ?? '')) return <></>

    return (
      <Box flex={1} align='center' justifyContent='center'>
        <Box>
          <Typography variant='span' size='16px' style={{fontWeight: 500}} children={handleTitlesAndSubtitlesForDetections().title} />
          <Typography variant='p' size='12px' color='#8E8E8E' children={handleTitlesAndSubtitlesForDetections().subtitle} />
        </Box>

        <Box paddingTop='20px'>
          {detectionsWithSimpleChoicesToRecognition.includes(chosen.detectionTypeChosen!.toLowerCase()) ? (
            <Dropdown
              height='40px'
              fontSize='12px'
              selected={detectionTypeOnDropdownSelected}
              placeholder={chosen!.detectionTypeChosen}
              items={countingObjectsOptions}
              onChangeSelected={(e) => {
                const registeredAreaIds = registeredObjects?.map((it) => it.interestArea?.id)
                const registeredObjectIds = registeredObjects?.map((it) => it.objectType.id)
                const alreadyHaveThisResourceRegistered = registeredObjectIds?.includes(+e.id)
                const alreadyHaveThisAreaRegistered = registeredAreaIds?.includes(chosen?.interestAreaId!)
                if (alreadyHaveThisAreaRegistered && alreadyHaveThisResourceRegistered && chosen && !chosen.isObjectCounting) {
                  enqueueSnackbar('Já existe uma detecção desse objeto nessa área, por favor selecione outra', {variant: 'warning'})
                } else {
                  setDetectionTypeOnDropdownSelected(e)
                  setChosen({objectTypeId: Number(e.id)})
                }
              }}
            />
          ) : (
            <MultiSelect onChange={(selections) => handleMultipleSelectionsFunction(selections)} value={selectedMultipleItensToCheck} loading={false}>
              <MultiSelectValue placeholder={'Selecione uma ou mais opções'} width='100%' />
              <MultiSelectContent>
                <MultiSelectScrollView>
                  {multipleOptionsOnMultiSelect.map((item) => (
                    <MultiSelectItem value={item.value} label={item.label}>
                      {item.label}
                    </MultiSelectItem>
                  ))}
                </MultiSelectScrollView>
              </MultiSelectContent>
            </MultiSelect>
          )}
        </Box>
      </Box>
    )
  }

  useEffect(() => {
    if (!isEdit || !chosen) return
    if (chosen.detectionTypeChosen?.toLowerCase().includes('relatório de contagem')) {
      const detectionTypeToCount = allObjects.find((it) => it.id === chosen.objectTypeId)
      if (detectionTypeToCount) setDetectionTypeOnDropdownSelected({id: `${chosen.objectTypeId}`, label: detectionTypeToCount.label})
      return
    }

    const epi = epiOptions.filter((option) => chosen.detectionsOptionsSelected?.includes(option.value))
    const vehicle = vehicleOptions.filter((option) => chosen.detectionsOptionsSelected?.includes(option.value))
    const animal = animalsOptions.filter((option) => chosen.detectionsOptionsSelected?.includes(option.value))
    const obj = objectsOptions.filter((option) => chosen.detectionsOptionsSelected?.includes(option.value))
    const selection = epi.length ? epi : vehicle.length ? vehicle : animal.length ? animal : obj
    setSelectedMultipleItensToCheck(selection)
  }, [chosen, isEdit])

  useEffect(() => {
    if (amountOfDetectionSelected) setChosen({threshold: Number(amountOfDetectionSelected)})
    if (valueSlider) setChosen({confidence: valueSlider / 100})
  }, [amountOfDetectionSelected, valueSlider])

  useEffect(() => {
    if (!chosen?.detectionTypeChosen) return
    if (chosen?.detectionTypeChosen.toLowerCase() === 'epi') setMultipleOptionsOnMultiSelect(epiOptions)
    if (chosen?.detectionTypeChosen.toLowerCase() === 'veículos') setMultipleOptionsOnMultiSelect(vehicleOptions)
    if (chosen?.detectionTypeChosen.toLowerCase() === 'animais') setMultipleOptionsOnMultiSelect(animalsOptions)
    if (chosen?.detectionTypeChosen.toLowerCase() === 'objetos em geral') setMultipleOptionsOnMultiSelect(objectsOptions)
  }, [chosen])

  return (
    <ConfigContainer>
      <Box
        padding={windowSize.height <= 720 ? '0px' : '20px'}
        display='flex'
        direction='column'
        rowGap={windowSize.height <= 750 ? '10px' : '55px'}
        height='100%'>
        <Grid>
          <DropdownToChooseTypeOfObjects />
          <ThresholdComponent
            chosen={chosen}
            amountOfDetectionSelected={amountOfDetectionSelected}
            setAmountOfDetectionSelected={setAmountOfDetectionSelected}
          />
        </Grid>

        <ToleranceThreshold chosen={chosen} toleranceThresholdValue={toleranceThresholdValue} setToleranceThresholdValue={setToleranceThresholdValue} />
        <PermanenceThreshold chosen={chosen} permanenceThresholdValue={chosen?.maximumTime ?? 10} setChosen={setChosen} />
        <ConfidenceSliderComponent chosen={chosen} valueSlider={valueSlider} setValueSlider={setValueSlider} />

        <Box display='flex' direction='column'>
          {!skipFourthStep.includes(chosen?.detectionTypeChosen ?? '') && (
            <>
              <Checkbox
                labelSize='14px'
                label='Desejo criar uma ação de saída'
                checked={checkboxState}
                disabled={!!actions.length}
                onChange={() => setCheckboxState((prev) => !prev)}
              />
              <Typography variant='span' size='12px' color='#8E8E8E'>
                Essa ação permite você selecionar o que deverá acontecer caso haja a detecção
              </Typography>
            </>
          )}
        </Box>
      </Box>

      <StepperModalActionsButtonContainer paddingTop='0px'>
        <Button disabled={isEdit} fontSize='12px' height='40px' width='150px' variant='outlined' color='#8E8E8E' onClick={() => returnFunction(1)}>
          Voltar
        </Button>
        <Button
          fontSize='12px'
          disabledTextColor='#8E8E8E'
          height='40px'
          width='150px'
          onClick={() => functionNextButton()}
          disabled={functionToDisabledButton()}>
          {labelNextButton()}
        </Button>
      </StepperModalActionsButtonContainer>
    </ConfigContainer>
  )
}

export default ConfigStep
